import { ReactNode } from "react";

export type IGhgCategory =
  | "scope_1_1"
  | "scope_1_2"
  | "scope_1_3"
  | "scope_1_4"
  | "scope_2_1"
  | "scope_2_2"
  | "scope_2_3"
  | "scope_2_4"
  | "scope_3_1"
  | "scope_3_2"
  | "scope_3_3"
  | "scope_3_4"
  | "scope_3_5"
  | "scope_3_6"
  | "scope_3_7"
  | "scope_3_8"
  | "scope_3_9"
  | "scope_3_10"
  | "scope_3_11"
  | "scope_3_12"
  | "scope_3_13"
  | "scope_3_14"
  | "scope_3_15";

export interface IGetGhg {
  scope_1_1: number;
  scope_1_2: number;
  scope_1_3: number;
  scope_1_4: number;
  scope_2_1: number;
  scope_2_2: number;
  scope_2_3: number;
  scope_2_4: number;
  scope_3_1: number;
  scope_3_2: number;
  scope_3_3: number;
  scope_3_4: number;
  scope_3_5: number;
  scope_3_6: number;
  scope_3_7: number;
  scope_3_8: number;
  scope_3_9: number;
  scope_3_10: number;
  scope_3_11: number;
  scope_3_12: number;
  scope_3_13: number;
  scope_3_14: number;
  scope_3_15: number;
  scope_1: number;
  scope_2: number;
  scope_3: number;
  total: number;
}

export interface IScopeLevel {
  label: string;
  key: IGhgCategory;
  component?: ReactNode;
}

export interface IScope {
  label: string;
  levels: IScopeLevel[];
  key: "scope_1" | "scope_2" | "scope_3";
}

export const scopes: IScope[] = [
  {
    label: "Scope 1",
    key: "scope_1",
    levels: [
      {
        label: "1.1. Stationary combustion",
        key: "scope_1_1",
      },
      {
        label: "1.2. Mobile combustion",
        key: "scope_1_2",
      },
      {
        label: "1.3. Fugitive combustion",
        key: "scope_1_3",
      },
      {
        label: "1.4. Process combustion",
        key: "scope_1_4",
      },
    ],
  },
  {
    label: "Scope 2",
    key: "scope_2",
    levels: [
      {
        label: "2.1. Purchased electricity",
        key: "scope_2_1",
      },
      {
        label: "2.2. Purchased steam",
        key: "scope_2_2",
      },
      {
        label: "2.3. Purchased heating",
        key: "scope_2_3",
      },
      {
        label: "2.4. Purchased cooling",
        key: "scope_2_4",
      },
    ],
  },
  {
    label: "Scope 3",
    key: "scope_3",
    levels: [
      {
        label: "3.1. Purchased goods and services",
        key: "scope_3_1",
      },
      {
        label: "3.2. Capital goods",
        key: "scope_3_2",
      },
      {
        label: "3.3. Fuel- and energy-related activities",
        key: "scope_3_3",
      },
      {
        label: "3.4. Upstream transportation and distribution",
        key: "scope_3_4",
      },
      {
        label: "3.5. Waste generated in operations",
        key: "scope_3_5",
      },
      {
        label: "3.6. Business travel",
        key: "scope_3_6",
      },
      {
        label: "3.7. Employee commuting",
        key: "scope_3_7",
      },
      {
        label: "3.8. Upstream leased assets",
        key: "scope_3_8",
      },
      {
        label: "3.9. Downstream transportation and distribution",
        key: "scope_3_9",
      },
      {
        label: "3.10. Processing of sold products",
        key: "scope_3_10",
      },
      {
        label: "3.11. Use of sold products",
        key: "scope_3_11",
      },
      {
        label: "3.12. End of life treatment of sold products",
        key: "scope_3_12",
      },
      {
        label: "3.13. Downstream leased assets",
        key: "scope_3_13",
      },
      {
        label: "3.14. Franchises",
        key: "scope_3_14",
      },
      {
        label: "3.15. Investments",
        key: "scope_3_15",
      },
    ],
  },
];
